module.exports = __webpack_public_path__ + "img/lvhua_icon.723e87ee.png";